import { clubFetch } from '@club/api/utils'
import categoryMapper from '@club/api/mapper/category'
import type { Category } from '@club/types/Category'
import type { Pagination } from '@club/types/Pagination'

export default class CategoryAPI {
  fetchAll (options: { communityId?: number; communityExternalIds?: string[]; } = {}): Promise<{ items: Category[], pagination: Pagination }> {
    const { communityExternalIds, communityId } = options
    const params: Record<string, unknown> = {}

    if (communityId) {
      params['community.id'] = communityId
    }
    if (communityExternalIds) {
      params['external_id[]'] = communityExternalIds
    }

    return clubFetch<{ 'hydra:member': unknown[] }>('/categories', { params })
      .then(response => {
        const items: Category[] = response['hydra:member']
          .map<Category>(item => categoryMapper.toClient(item))
        return {
          items,
          pagination: {} as Pagination
        }
      })
  }
}
